import React from 'react';
import { StatsCard } from 'common/components';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import DataTable from 'UI/components/organisms/DataTable';

import { updatePeriodIds } from '../../commissionsBoard.utils';

import { COLUMNS, ORDER_BY_OPTIONS } from './CommissionsBoardTransactions.columns';

const TABLE_KEY = TABLES_KEYS.commissionsBoardTables;
const initialPreferences = getColumnPreferences(TABLE_KEY, 0, ORDER_BY_OPTIONS, COLUMNS);

export const CommissionsBoardTransactions = ({ queryParams, selectedPayPeriodId }) => {
  const updatedParams = updatePeriodIds(queryParams, selectedPayPeriodId);
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.commissionsBoardTransactions}?${updatedParams}`;

  const {
    columnPreferences,
    count,
    data,
    handleColumnSortChange,
    handlePageChange,
    handlePerPageChange,
    listState
  } = useDatatable({
    apiInstance: SECONDARY_API_CLIENT,
    columnsDefinitions: COLUMNS,
    endpoint,
    initialPreferences,
    orderByOptions: ORDER_BY_OPTIONS
  });

  const { isLoading, showWholeSkeleton, page, perPage } = listState;
  const { columns } = columnPreferences;
  const finalColumns = getColumnsToRender(columns);

  return (
    <StatsCard header={strings.commandCenter.commissionsBoard.rightTableTitle} paddingContent={0}>
      <DataTable
        columns={finalColumns}
        components={{ TableToolbar: () => null }}
        count={count}
        data={data}
        elevation={0}
        filter={false}
        loading={showWholeSkeleton}
        onColumnSortChange={handleColumnSortChange}
        onPageClick={handlePageChange}
        onPerPageClick={handlePerPageChange}
        page={page}
        refreshing={isLoading}
        rowsPerPage={perPage}
        search={false}
        selectableRows="none"
        viewColumns={false}
      />
    </StatsCard>
  );
};
